const swiperTimelineHistory = {
    swiperInstance: null,
    swiperInstancePagination: null,

    init: () => {
        import('swiper/bundle').then(({Swiper}) => {

            let domEl = document.getElementById('js-swiper-timeline-history');
            let domElPagination = document.getElementById('js-swiper-timeline-history-pagination');

            if (domEl && domElPagination) {
                const paginationParams = getSwiperPaginationParams();
                const params = getSwiperParams();

                swiperTimelineHistory.swiperInstancePagination = new Swiper(domElPagination, paginationParams);   //NOSONAR
                swiperTimelineHistory.swiperInstance = new Swiper(domEl, params);   //NOSONAR

                function slideOtherGalleryTo(sGalleryName, nSlideIndex) {
                    sGalleryName.slideTo(nSlideIndex);
                }

                // actions on transitionStart of main swiper
                swiperTimelineHistory.swiperInstance.on('transitionStart', function () {
                    let activeIndex = this.realIndex;
                    slideOtherGalleryTo(swiperTimelineHistory.swiperInstancePagination, activeIndex);
                });

                // actions on transitionStart of thumbs
                swiperTimelineHistory.swiperInstancePagination.on('transitionStart', function () {
                    let activeIndex = this.realIndex;
                    slideOtherGalleryTo(swiperTimelineHistory.swiperInstance, activeIndex);
                });
            }
        })
    }
};

const getSwiperPaginationParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        speed: 500,
        a11y: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                allowTouchMove: false,
            }
        },
        on: {
            // since we want the previous years on the left, we start with the last slide
            init: function () {
                this.slideTo(this.slides.length - 1, 0, false);
            }
        }
    };
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        slidesPerView: 1,
        speed: 500,
        slideToClickedSlide: false,
        resizeObserver: true,
        a11y: true,
        effect: "fade",
        allowTouchMove: false,
        autoHeight: true,
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
        thumbs: {
            swiper: swiperTimelineHistory.swiperInstancePagination,
        },
        on: {
            // since we want the previous years on the left, we start with the last slide
            init: function () {
                this.slideTo(this.slides.length - 1, 0, false);
            }
        }
    }
}

export default swiperTimelineHistory;